import React, { useState, useEffect, useCallback, useRef } from "react";
import { Auth } from "aws-amplify";
import { jwtDecode } from "jwt-decode";
import { useNavigate, useLocation } from "react-router-dom";
import { useLoading } from "../../../context/LoadingContext";
import { getParameterFromManager } from "../../../services/Utils";
import { v4 as uuidv4 } from "uuid";
import DataTable from "../../Requirement/components/common/ReusableTable";
import SearchFilter from "../../Requirement/components/common/SearchFilter";
import AlertModal from "../../Requirement/components/common/AlerModel";
import {
  fetchData,
  postQuery,
} from "../../Requirement/services/RequirementServices";
import {
  FormControl,
  TextField,
  Typography,
  Button,
  Select,
  MenuItem,
} from "@mui/material";
import StratigicPartners from "./StratigicPartners";
import ProcurementProjects from "./ProcurementProjects";
import ProcurementDocumentTypes from "./ProcurementDocumentTypes";
import Seller from "./Seller";

const ProcurementMasterModule = () => {
  const [activeUser, setActiveUser] = useState("");
  const [activeTab, setActiveTab] = useState("Strategic Partners");
  const { setLoading } = useLoading();
  const navigate = useNavigate();

  const tabs = [
    "Strategic Partners",
    "Projects",
    "Document Types",
    "Sellers",
  ];

  useEffect(() => {
    const checkUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        const decodedToken = jwtDecode(token);

        const groups = decodedToken["cognito:groups"] || [];
        if (!groups.includes("AMTPL_ADMINS")) {
          await Auth.signOut();
          navigate("/");
        }else {
            setActiveUser(user.attributes.email);
          }
        await getParameterFromManager("INR_TO_USD");
      } catch (error) {
        await Auth.signOut();
        navigate("/");
      }
    };

    checkUser();
  }, [navigate]);

  const renderTabContent = () => {
    switch (activeTab) {
      case "Strategic Partners":
        return <StratigicPartners />;
      case "Projects":
        return <ProcurementProjects />;
      case "Document Types":
        return <ProcurementDocumentTypes />;
      case "Sellers":
        return <Seller />;
      default:
        return <StratigicPartners />;
    }
  };

  return (
    <div className="buyer-layout">
      <div className="amtpl-tabs">
        <div className="content3">
          <main className="main-content">
            <div className="mb-3 main-tab">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  className={`buttonclass ${
                    activeTab === tab ? "active" : "notactive"
                  }`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
            <div className="row">{renderTabContent()}</div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default ProcurementMasterModule;
